/**
 * Mapira relativne putanje iz API-ja (obavještenja: `/projects/{id}`, `/measurements/{id}`,
 * `/production`, `/settings/users`) na rute panela.
 */
import type { NavigateOptions } from '@tanstack/react-router';

import type { SettingsTab } from '@/router';

export type NavTarget = NavigateOptions;

export function notificationTarget(link: string | null | undefined): NavTarget | null {
  if (!link) return null;
  let url: URL;
  try {
    url = new URL(link, 'http://x');
  } catch {
    return null;
  }
  const parts = url.pathname.split('/').filter(Boolean);
  const qp = url.searchParams;
  const [head, id] = parts;
  switch (head) {
    case 'projects':
    case 'projekti':
      if (!id) return { to: '/projekti' };
      return {
        to: '/projekti/$projectId',
        params: { projectId: id },
        search: {
          tab: (qp.get('tab') as 'positions' | null) ?? undefined,
          position: qp.get('position') ?? undefined,
          doc: undefined,
        },
      };
    case 'measurements':
    case 'mjerenja':
      return { to: '/mjerenja', search: { m: id, position: undefined } };
    case 'production':
    case 'proizvodnja':
      return { to: '/proizvodnja', search: { order: id } };
    case 'photos':
    case 'fotodokumentacija':
      return {
        to: '/fotodokumentacija',
        search: { photo: id, cat: undefined, project: undefined },
      };
    case 'settings':
    case 'podesavanja': {
      const map: Record<string, SettingsTab> = {
        users: 'korisnici',
        korisnici: 'korisnici',
        organization: 'organizacija',
        rules: 'pravila',
        features: 'funkcije',
        profile: 'profil',
        devices: 'uredjaji',
        support: 'podrska',
        'support-access': 'podrska',
        subscription: 'paket',
        plan: 'paket',
        paket: 'paket',
      };
      // `/settings/support/{reportId}` otvara izvještaj podrške
      const report = id === 'support' ? parts[2] : undefined;
      return {
        to: '/podesavanja',
        search: { tab: id ? map[id] : undefined, ...(report ? { report } : {}) },
      };
    }
    case 'analytics':
      return { to: '/analiza' };
    default:
      return { to: '/' };
  }
}
